import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
  fetchExport,
  fetchProduct,
} from "../pages/product/productSlice";
import { LayoutSplashScreen } from "../../_metronic/layout";
import { CallApiExport, showErrorDialog } from ".";
import {
  headerSortingClasses,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from "../../_metronic/_helpers";
import {
  CallApi,
  formatDate,
  formatDateTime,
  replaceNulls,
  sizePerPageList,
} from "./util";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  fetchDatalog,
  fetchIdDatalog,
  selectDatalog,
} from "../pages/customer/customerSlice";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import SVG from "react-inlinesvg";

import {
  FaAngleDoubleDown,
  FaAngleDoubleUp,
  FaAngleDown,
  FaAngleRight,
  FaAngleUp,
} from "react-icons/fa";

export const ModalDatalog = ({
  show,
  setShow,
  id,
  fetched,
  setFetched,
  showDetail,
  setShowDetail,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectDatalog);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  const { SearchBar } = Search;

  // Filter
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (show && id && !fetched) {
      dispatch(fetchDatalog({ pageNo: 1, pageSize: -1, obj_id: id }));
      setFetched(true);
    }
  }, [show, id, fetched, dispatch]);

  console.log(fetched, "fetched");

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData = data.map((item, index) => {
      const newItem = replaceNulls(item);
      return {
        ...newItem,
        no: index + 1 + pageBefore,
      };
    });

    console.log(initData);
    setTableData(initData);
  }, [data, pageSize, pageNo]);

  const paramsFilter = {
    // product_code: code,
    // product_name: name,
    obj_id: id,
  };

  const actionFormatter = (e, row) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
            onClick={() => {
              CallApi(
                "00cac24a-2245-4658-beb8-bb65e392f9fc",
                fetchIdDatalog,
                dispatch
              );
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-secondary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },
    {
      text: "action type",
      dataField: "action_type",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "created by",
      dataField: "created_by",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "created_at",
      dataField: "created_at",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatDateTime,
    },
    // {
    //   text: "Action",
    //   dataField: "action",
    //   align: "center",
    //   formatter: actionFormatter,
    //   style: { minWidth: "100px" },
    // },
  ];

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList(totalRecord),
  };

  const handleClose = () => {
    setShow(false);
  };

  const expandRow = {
    expandByColumnOnly: true,
    showExpandColumn: true,
    // expanded: [0, 1],
    renderer: (row) => (
      <div>
        {row.diff ? (
          <table className="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Field</th>
                <th>Old Value</th>
                <th>New Value</th>
              </tr>
            </thead>
            <tbody>
              {row.diff.map((d, i) => (
                <tr key={i}>
                  <td>{d.field}</td>
                  <td style={{ color: "red" }}>{d.old ?? "-"}</td>
                  <td style={{ color: "green" }}>{d.new ?? "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <em>Loading detail...</em>
        )}
      </div>
    ),
    expandColumnRenderer: ({ expanded }) =>
      expanded ? <FaAngleUp /> : <FaAngleDown />,
    expandHeaderColumnRenderer: ({ isAnyExpands }) =>
      isAnyExpands ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />,
    align: "center",
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      dialogClassName="modal-70"
    >
      <Modal.Header closeButton>
        <Modal.Title>Datalog</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          className="card-body pt-0"
          style={{
            // height: "650px",
            overflowY: "scroll",
          }}
        >
          <ToolkitProvider
            keyField="no"
            data={tableData}
            columns={columns}
            search
          >
            {(props) => (
              <div>
                <Row>
                  <Col>
                    <div className="float-right">
                      <SearchBar
                        {...props.searchProps}
                        placeholder="Search .."
                      />
                    </div>
                  </Col>
                </Row>
                <div className="table-container">
                  <BootstrapTable
                    striped
                    noDataIndication="Data Not Found"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    bordered={true}
                    {...props.baseProps}
                    expandRow={expandRow}
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </div>
      </Modal.Body>
    </Modal>
  );
};
